<template>
    <div id="timer" :class="class">{{ text }}</div>
</template>

<script>
export default {
    name: "tender_time",
    props: {
        // ISO 'YYYY-MM-DD HH:mm:ss' или 'YYYY-MM-DDTHH:mm:ss'
        dateFrom: { type: String, required: true },
        dateTo:   { type: String, required: true },
        
        now:      { type: [Number, String, Date], default: null },
        tickMs:   { type: Number, default: 1000 }, // шаг тика
    },
    data() {
        return {
            nowMs: 0,
            timer: null,
        };
    },
    
    computed: {
        fromMs() { return toMs(this.dateFrom); },
        toMs()   { return toMs(this.dateTo); },
        
        state() {
            if (this.nowMs >= this.toMs)  return 'ended';
            if (this.nowMs <  this.fromMs) return 'before';
            return 'active';
        },
        
        text() {
            const fmt = (secTotal) => {
                const d = Math.floor(secTotal / 86400);  secTotal %= 86400;
                const h = Math.floor(secTotal / 3600);   secTotal %= 3600;
                const m = Math.floor(secTotal / 60);
                const s = Math.floor(secTotal % 60);
                const pad = (n) => n.toString().padStart(2,'0');
                return { d, h, m: pad(m), s: pad(s) };
            };
            
            if (this.state === 'ended') {
                return `Прийом заявок завершено ${formatOut(this.dateTo)}`;
            }
            if (this.state === 'before') {
                const sec = Math.max(0, Math.floor((this.fromMs - this.nowMs) / 1000));
                const t = fmt(sec);
                return `Прийом заявок почнеться через ${t.d} дн. ${t.h} год. ${t.m} хв. ${t.s} сек.`;
            }
            // active
            const sec = Math.max(0, Math.floor((this.toMs - this.nowMs) / 1000));
            const t = fmt(sec);
            return `До завершення ${t.d} дн. ${t.h} год. ${t.m} хв. ${t.s} сек.`;
        },
        
        class() {
            return {
                'p-2': true, 'mb-4': true,
                'complite': this.state === 'ended',
                'infuture': this.state === 'before',
                'nowactive': this.state === 'active',
            };
        },
    },
    watch: {
        now: {
            immediate: true,
            handler(v) {
                // синхронизируемся с родителем
                this.nowMs = v != null ? toMs(v) : Date.now();
            }
        }
    },
    
    mounted() {
        // тикаем локально от базового nowMs
        this.timer = setInterval(() => { this.nowMs += this.tickMs; }, this.tickMs);
    },
    
    beforeUnmount() {
        clearInterval(this.timer);
    }
}

// helpers
function toMs(v) {
    if (v instanceof Date) return v.getTime();
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
        // поддержка "YYYY-MM-DD HH:mm:ss"
        const iso = v.includes('T') ? v : v.replace(' ', 'T');
        const t = Date.parse(iso);
        return isNaN(t) ? Date.now() : t;
    }
    return Date.now();
}
function formatOut(v) {
    // отдаём как пришло; можно заменить на локальный форматтер
    return typeof v === 'string' ? v : new Date(toMs(v)).toISOString().replace('T',' ').slice(0,19);
}
</script>



<style scoped>

.complite {background: #d3123e;color: white;}
.infuture {background: #ffc24185;}
.nowactive {background: green;color: white;}
</style>